/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmitModuleFeedback } from './submitModuleFeedback';

export type ModuleSubmissionResponseGrading = SubmitModuleFeedback | null;
